import { render, staticRenderFns } from "./InconsistenciasModal.vue?vue&type=template&id=bf2bc44e&scoped=true&"
import script from "./InconsistenciasModal.vue?vue&type=script&lang=js&"
export * from "./InconsistenciasModal.vue?vue&type=script&lang=js&"
import style0 from "./InconsistenciasModal.vue?vue&type=style&index=0&id=bf2bc44e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2bc44e",
  null
  
)

export default component.exports